export const LevelConversion = {
  3: "#00b0ff", // blue - proficient
  2: "#00e676", // green - experienced
  1: "#ff9800", // orange - familiar
};

export const Languages = [
  {
    name: "Python",
    level: 3,
    blurb: "You love it or you hate it.",
  },
  {
    name: "Java",
    level: 3,
    blurb: "My first language!",
  },
  {
    name: "HTML/CSS",
    level: 3,
    blurb: "*Everyone liked that*",
  },
  {
    name: "Javascript",
    level: 2,
    blurb: "console.log(everything)",
  },
  {
    name: "Go",
    level: 2,
    blurb: "So fast!",
  },
  {
    name: "C",
    level: 2,
    blurb: "Segmentation fault (core dumped)",
  },
  {
    name: "C++",
    level: 2,
    blurb: "C++ > C",
  },
  {
    name: "OCaml",
    level: 1,
    blurb: "Recursion is life.",
  },
  {
    name: "Bash",
    level: 1,
    blurb: "[ ] vs. [[ ]]",
  },
  {
    name: "R",
    level: 1,
    blurb: "So. Many. Graphs.",
  },
  {
    name: "MIPS/Assembly",
    level: 1,
    blurb: "Oh boy...",
  },
];

export const Technologies = [
  {
    name: "Git",
    level: 3,
    blurb: "I <3 merge conflicts!",
  },
  {
    name: "React.js",
    level: 3,
    blurb: "React > Angular",
  },
  {
    name: "Unix/Linux",
    level: 2,
    blurb: "rm -rf * ...oops",
  },
  {
    name: "Node.js",
    level: 2,
    blurb: "My first backend framework!",
  },
  {
    name: "Express.js",
    level: 2,
    blurb: "Name a more iconic duo than Node & Express.",
  },
  {
    name: "MongoDB",
    level: 2,
    blurb: "My first DB used!",
  },
  {
    name: "RocksDB",
    level: 2,
    blurb: "My research project focus!",
  },
  {
    name: "Docker",
    level: 1,
    blurb: "Containerization!",
  },
  {
    name: "JUnit",
    level: 1,
    blurb: "Testing for days...",
  },
  {
    name: "MySQL",
    level: 1,
    blurb: "Probably should've learnt this first :)",
  },
];

export const Miscellaneous = [
  {
    name: "Figma",
  },
  {
    name: "Wireshark",
  },
  {
    name: "Procreate",
  },
  {
    name: "about:miscellaneous.chess",
  },
  {
    name: "about:miscellaneous.running",
  },
  {
    name: "about:miscellaneous.cooking",
  },
];
